export default "__VITE_ASSET__CJ94$mDm__"